import _ from 'lodash';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { channels } from '../../../test.data';
import { Channel, TinyChannel } from '../../../types/channel.types';
import ChannelCard from '../../cards/v2/channel.card';
import Container from '../container';

type ChannelQuery = 'JOINED' | 'RECOMMENDED' | 'TRENDING';

type Props = {
  trigger: Function;
  query: ChannelQuery[];
};

export default function ChannelsContainer(props: Props) {
  const { trigger, query } = props;
  const navigate = useNavigate();

  const data = [];
  // temporary data querying from local data store
  if (query) {
    for (const q of query) {
      data.push(...GET[q]());
    }
  }

  const openChannel = (id: string) => {
    navigate(`${id}`);
  };

  return (
    <Container extensions="grid mobile:grid-cols-1 tablet-lg:grid-cols-2 gap-2 mobile:px-2 tablet-lg:px-[40px] mobile:py-1.5 tablet-lg:py-2">
      {data.map((channel: TinyChannel) => (
        <ChannelCard
          onClick={
            channel.hasJoined ? () => openChannel(channel.id || '') : trigger
          }
          key={channel.id}
          channel={channel}
        />
      ))}
    </Container>
  );
}

type ChannelQueryMap = { [key in ChannelQuery]: Function };

const tinyChannelKeys = [
  'id',
  'title',
  'backgroundImage',
  'administrator',
  'pinnedMessage',
  'topListners',
  'hasJoined',
  'isPrivate',
  'tags',
];

const GET: ChannelQueryMap = {
  RECOMMENDED: (): TinyChannel[] => {
    const filteredChannels: Channel[] = channels.filter(
      (channel) => channel.hasJoined === false
    );
    return filteredChannels.map((channel) => ({
      ..._.pick(channel, [...tinyChannelKeys]),
      listenersCount: channel.listeners.length,
    }));
  },
  JOINED: (): TinyChannel[] => {
    const filteredChannels: Channel[] = channels.filter(
      (channel) => channel.hasJoined === true
    );
    return filteredChannels.map((channel) => ({
      ..._.pick(channel, [...tinyChannelKeys]),
      listenersCount: channel.listeners.length,
    }));
  },
  TRENDING: (): TinyChannel[] => {
    const filteredChannels: Channel[] = channels.filter(
      (channel) => channel.hasJoined === false
    );
    const sample = _.sampleSize(
      filteredChannels,
      _.random(2, filteredChannels.length - 1)
    );
    return sample.map((channel: Channel) => ({
      ..._.pick(channel, [...tinyChannelKeys]),
      listenersCount: channel.listeners.length,
    }));
  },
};
